module.exports = require("events");


/*****************
 ** WEBPACK FOOTER
 ** external "events"
 ** module id = 227
 ** module chunks = 0
 **/